// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-calendar {
  width: 100%;
}

.react-calendar__tile {
  position: relative;
}

.calendar-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(3, 1fr);
}

@media (max-width: 900px) {
  .calendar-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 500px) {
  .calendar-grid {
    grid-template-columns: 1fr;
  }
}

.react-calendar__month-view__days__day--weekend:not(.calendar-tile--generated):not(.calendar-tile--specified):not(.calendar-tile--pending):not(.calendar-tile--pending-remove) abbr {
  background-color: #e8f5e9;
  color: #2e7d32;
  font-weight: bold;
  border-radius: 50%;
  display: inline-block;
  width: 2em;
  line-height: 2em;
}

.calendar-tile--generated abbr {
  background-color: #075e5b;
  border-radius: 50%;
  display: inline-block;
  width: 2em;
  line-height: 2em;
  color: #fff;
}

.calendar-tile--specified abbr {
  background-color: #f6ae2d;
  border-radius: 50%;
  display: inline-block;
  width: 2em;
  line-height: 2em;
  color: #fff;
}

.calendar-tile--pending abbr {
  background-color: #7b9cff;
  border-radius: 50%;
  display: inline-block;
  width: 2em;
  line-height: 2em;
  color: #fff;
  outline: 2px dashed #4a6ef5;
  outline-offset: 2px;
}

.calendar-tile--pending-remove abbr {
  background-color: #ccc;
  border-radius: 50%;
  display: inline-block;
  width: 2em;
  line-height: 2em;
  color: #fff;
  outline: 2px dashed #999;
  outline-offset: 2px;
  text-decoration: line-through;
}

.calendar-tile--range-start abbr {
  outline: 2px solid #4a6ef5;
  outline-offset: 2px;
  border-radius: 50%;
}

.calendar-tile--generated:hover abbr,
.calendar-tile--specified:hover abbr,
.calendar-tile--pending:hover abbr,
.calendar-tile--pending-remove:hover abbr {
  opacity: 0.85;
}
`, "",{"version":3,"sources":["webpack://./src/pages/price_calculator/Calendar.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;AACf","sourcesContent":[".react-calendar {\n  width: 100%;\n}\n\n.react-calendar__tile {\n  position: relative;\n}\n\n.calendar-grid {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: repeat(3, 1fr);\n}\n\n@media (max-width: 900px) {\n  .calendar-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 500px) {\n  .calendar-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.react-calendar__month-view__days__day--weekend:not(.calendar-tile--generated):not(.calendar-tile--specified):not(.calendar-tile--pending):not(.calendar-tile--pending-remove) abbr {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n  font-weight: bold;\n  border-radius: 50%;\n  display: inline-block;\n  width: 2em;\n  line-height: 2em;\n}\n\n.calendar-tile--generated abbr {\n  background-color: #075e5b;\n  border-radius: 50%;\n  display: inline-block;\n  width: 2em;\n  line-height: 2em;\n  color: #fff;\n}\n\n.calendar-tile--specified abbr {\n  background-color: #f6ae2d;\n  border-radius: 50%;\n  display: inline-block;\n  width: 2em;\n  line-height: 2em;\n  color: #fff;\n}\n\n.calendar-tile--pending abbr {\n  background-color: #7b9cff;\n  border-radius: 50%;\n  display: inline-block;\n  width: 2em;\n  line-height: 2em;\n  color: #fff;\n  outline: 2px dashed #4a6ef5;\n  outline-offset: 2px;\n}\n\n.calendar-tile--pending-remove abbr {\n  background-color: #ccc;\n  border-radius: 50%;\n  display: inline-block;\n  width: 2em;\n  line-height: 2em;\n  color: #fff;\n  outline: 2px dashed #999;\n  outline-offset: 2px;\n  text-decoration: line-through;\n}\n\n.calendar-tile--range-start abbr {\n  outline: 2px solid #4a6ef5;\n  outline-offset: 2px;\n  border-radius: 50%;\n}\n\n.calendar-tile--generated:hover abbr,\n.calendar-tile--specified:hover abbr,\n.calendar-tile--pending:hover abbr,\n.calendar-tile--pending-remove:hover abbr {\n  opacity: 0.85;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
